import { gql } from 'apollo-angular';

export const GenerateUserStripeVerificationUrlDocument = gql`
  mutation generateUserStripeVerificationUrl {
    generateUserStripeVerificationUrl
  }
`;
